import React, { useEffect } from 'react'


export default function GoogleSignIn({ googCredentials }) {
    const handleCredentialResponse = async ({ credential }) => {
        const idToken = credential; // JWT from Google

        googCredentials(idToken)
    };

    const initializeGoogle = () => {
        if (window.google) {
            window.google.accounts.id.initialize({
                client_id: "258152730198-kk24aqqml2jffboe3dvpi485a4altobr.apps.googleusercontent.com",//process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID!,
                callback: handleCredentialResponse,
                auto_select: true
            });
            window.google.accounts.id.renderButton(
                document.getElementById("googleSignInDiv"),
                { theme: "outline", size: "large" }
            );
        }
    };

    useEffect(() => {
        // Create the script element
        const script = document.createElement('script');
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        script.onload = initializeGoogle; // Call initializeGoogle when the script loads

        // Append the script to the document body
        document.body.appendChild(script);

        // Cleanup function: remove the script when the component unmounts
        return () => {
            document.body.removeChild(script);
            // Optionally, if you have multiple Google sign-in instances or
            // are concerned about re-initialization, you might want to
            // add logic here to clean up window.google.accounts.id as well.
        };
    }, []);

    return (
        <>
            <div style={{ marginTop: "15px", textAlign: "center" }}>
                <div id="googleSignInDiv"></div>
            </div>
        </>
    )
}
